import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { createBrowserHistory, BrowserHistoryOptions } from 'history';

export const reactPlugin = new ReactPlugin();

export const setupAppInsights = () => {
  const connectionString = 'InstrumentationKey=ed3cda6b-8e06-4572-b120-2bd72e6ab036;IngestionEndpoint=https://westeurope-5.in.applicationinsights.azure.com/;LiveEndpoint=https://westeurope.livediagnostics.monitor.azure.com/;ApplicationId=9d2ffa30-475b-4642-af0a-3c1ad647a6dc';

  if (!connectionString) {
    console.error('Application Insights connection string is missing.');
    return;
  }

  const browserHistory = createBrowserHistory({ basename: '' } as BrowserHistoryOptions);

  const appInsights = new ApplicationInsights({
    config: {
      connectionString,
      extensions: [reactPlugin],
      enableAutoRouteTracking: true,
      disableAjaxTracking: false,
      autoTrackPageVisitTime: true,
      enableCorsCorrelation: true,
      enableRequestHeaderTracking: true,
      enableResponseHeaderTracking: true,
      correlationHeaderDomains: ['nps.today'],
      extensionConfig: {
        [reactPlugin.identifier]: { history: browserHistory }
      }
    }
  });

  appInsights.addTelemetryInitializer((envelope) => {
    envelope.tags = envelope.tags || [];
    envelope.tags.push({ "ai.cloud.role": "nps-puzzel" });
  });

  appInsights.loadAppInsights();
  console.log('Application Insights initialized.');
};